import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/utils';

interface SpinnerProps extends React.HTMLAttributes<SVGSVGElement> {
  size?: 'sm' | 'md' | 'lg';
}

const sizeClasses = {
  sm: 'size-4',
  md: 'size-6',
  lg: 'size-8',
};

export function Spinner({ className, size = 'md', ...props }: SpinnerProps) {
  return (
    <Loader2
      className={cn('animate-spin motion-reduce:animate-none', sizeClasses[size], className)}
      {...props}
    />
  );
}
